module.exports = __webpack_public_path__ + "img/lego-3.907a3220.jpg";